import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/logo.png';
const _withScopeId = n => (_pushScopeId("data-v-e8aef558"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "abusolute-center bg-white shadow-lg w-full sm:w-max rounded-lg" };
const _hoisted_2 = {
    class: "py-8 px-5 sm:px-12",
    id: "app"
};
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "flex justify-center p-4 border-red-700 border-b-4" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        class: "w-16",
        alt: "logo",
        src: _imports_0
    })
], -1));
const _hoisted_4 = {
    class: "py-8 px-5 sm:px-12",
    id: "app"
};
const _hoisted_5 = { class: "max-w-lg" };
const _hoisted_6 = { class: "block" };
const _hoisted_7 = { class: "text-gray-700" };
const _hoisted_8 = ["placeholder"];
const _hoisted_9 = { class: "block" };
const _hoisted_10 = { class: "text-gray-700" };
const _hoisted_11 = ["type", "placeholder"];
const _hoisted_12 = { class: "block" };
const _hoisted_13 = { class: "flex justify-center" };
const _hoisted_14 = { class: "block" };
const _hoisted_15 = { class: "flex justify-center" };
const _hoisted_16 = {
    key: 0,
    class: "modal"
};
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "overlay" }, null, -1));
const _hoisted_18 = { class: "modal-container" };
const _hoisted_19 = { class: "modal-body" };
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, "普段使用したことない端末でログインしますか", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ErrMsgCard = _resolveComponent("ErrMsgCard");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_ErrMsgCard, {
                            errMsgs: $data.errMsgs,
                            process: "ログイン"
                        }, null, 8, ["errMsgs"])
                    ]),
                    _createElementVNode("form", {
                        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.inputInfo && _ctx.inputInfo(...args)), ["prevent"])),
                        class: "grid grid-cols-1 gap-6 text-gray-700"
                    }, [
                        _createElementVNode("label", _hoisted_6, [
                            _createElementVNode("span", _hoisted_7, _toDisplayString($data.loginId.key), 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                placeholder: $data.loginId.key + 'を入力',
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($data.loginId.value) = $event)),
                                maxlength: "50",
                                class: "w-full"
                            }, null, 8, _hoisted_8), [
                                [_vModelText, $data.loginId.value]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_9, [
                            _createElementVNode("span", _hoisted_10, _toDisplayString($data.password.key), 1),
                            _withDirectives(_createElementVNode("input", {
                                type: $options.passInputType,
                                placeholder: $data.password.key + 'を入力',
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($data.password.value) = $event)),
                                maxlength: "50",
                                class: "w-full"
                            }, null, 8, _hoisted_11), [
                                [_vModelDynamic, $data.password.value]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("button", {
                                    button: "",
                                    onClick: _cache[2] || (_cache[2] =
                                        //@ts-ignore
                                        (...args) => ($options.submit && $options.submit(...args))),
                                    name: "button",
                                    class: "btn btn-red w-full"
                                }, " ログイン ")
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("button", {
                                    name: "button",
                                    onClick: _cache[3] || (_cache[3] =
                                        //@ts-ignore
                                        (...args) => ($options.resetPassword && $options.resetPassword(...args))),
                                    style: { "color": "blue" }
                                }, " パスワードをお忘れの方はこちら ")
                            ])
                        ])
                    ], 32)
                ])
            ])
        ]),
        ($data.isShowConfirmModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _createElementVNode("button", {
                            onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.$emit('answerdConfirm', true)))
                        }, "はい"),
                        _createElementVNode("button", {
                            onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.$emit('answerdConfirm', false)))
                        }, "いいえ")
                    ])
                ])
            ]))
            : _createCommentVNode("", true)
    ], 64));
}
